import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import BulkEmailForm from '../../../components/forms/BulkEmailForm';
import {BulkEmailClient, BulkEmailDTO} from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from "../../../services/axiosInstance";

const BulkEmailEdit: React.FC = () => {
    const [initialValues, setInitialValues] = useState<BulkEmailDTO | null>({});
    const [attachmentFile, setAttachmentFile] = useState<File | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const apiClient = new BulkEmailClient(API_BASE_URL, axiosInstance);

    const breadcrumbs = [
        { label: 'Admin', href: '#' },
        { label: 'Bulk Emails', href: '/admin/bulkemails' },
        { label: 'Edit', href: '#' },
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiClient.getBulkEmailById(id!);
                setInitialValues(response.data || null);
            } catch (error) {
                console.error('Error fetching bulk email:', error);
            }
        };

        fetchData();
    }, [id]);

    const handleSubmit = async (data: any) => {
        setIsSubmitting(true);
        try {
            let updatedValues = { ...initialValues };

            // If there's an attachment file, upload it and add the attachmentPath to updatedValues
            if (attachmentFile) {
                const response = await apiClient.uploadBulkEmailAttachment(
                    attachmentFile.name,
                    attachmentFile
                );
                if (response && response.success && response.data) {
                    updatedValues = { ...updatedValues, attachmentPath: response.data };
                }
            }
            
            await apiClient.updateBulkEmail(updatedValues.id!, updatedValues);
            navigate('/admin/bulkemails');
        } catch (error) {
            console.error('Error updating bulk email:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <AdminLayout
            title="Edit Bulk Email"
            breadcrumbs={breadcrumbs}
            allowedRoles={['Administrator']}
        >
            <Card>
                {initialValues ? (
                    <BulkEmailForm
                        initialValues={initialValues}
                        setInitialValues={setInitialValues}
                        setAttachmentFile={setAttachmentFile}
                        onSubmit={handleSubmit}
                        onCancel={() => navigate('/admin/bulkemails')}
                    />
                ) : (
                    <p>Loading...</p>
                )}
            </Card>
        </AdminLayout>
    );
};

export default BulkEmailEdit;
